module.exports = __webpack_public_path__ + "img/H4.47f08cf4.png";